// src/components/modals/CountryEditModal.js
import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal'; // Genel Modal bileşeniniz
import styles from './CountryEditModal.module.css'; // Yeni CSS modülü

// Hangi dil alanlarının düzenleneceğini tanımlayalım
// Bu, CountriesPage'deki displayLanguageFields ile senkronize olabilir veya farklı olabilir.
// Tüm dilleri kapsayan alanlar
const editableLanguageFields = [
    { key: 'countryTR', label: 'Türkçe Adı' },
    { key: 'countryDE', label: 'Almanca Adı' },
    { key: 'countryFR', label: 'Fransızca Adı' },
    { key: 'countryES', label: 'İspanyolca Adı' },
    { key: 'countryAR', label: 'Arapça Adı' },
    { key: 'countryPT', label: 'Portekizce Adı' },
    { key: 'countryRU', label: 'Rusça Adı' },
    { key: 'countryUR', label: 'Urduca Adı' },
    { key: 'countryIT', label: 'İtalyanca Adı' },
    { key: 'countrySR', label: 'Sırpça Adı' },
    { key: 'countryID', label: 'Endonezce Adı' },
    { key: 'countryMK', label: 'Makedonca Adı' },
    { key: 'countryHU', label: 'Macarca Adı' },
    { key: 'countryJA', label: 'Japonca Adı' },
    { key: 'countryZH', label: 'Çince Adı' },
    { key: 'countryTH', label: 'Tayca Adı' },
];


const CountryEditModal = ({ isOpen, onClose, countryData, onSave, error: externalError }) => {
  const [formData, setFormData] = useState({
    country: '', // Bu alan path'te kullanılacak, belki düzenlenemez olmalı?
    flag: '',
    isActive: true,
    countryDE: '',
    countryTR: '',
    countryFR: '',
    countryES: '',
    countryAR: '',
    countryPT: '',
    countryRU: '',
    countryUR: '',
    countryIT: '',
    countrySR: '',
    countryID: '',
    countryMK: '',
    countryHU: '',
    countryJA: '',
    countryZH: '',
    countryTH: '',
  });
  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (countryData) { // Düzenleme modu
      setFormData({
        country: countryData.country || '',
        flag: countryData.flag || '',
        isActive: countryData.isActive === undefined ? true : countryData.isActive,
        countryDE: countryData.countryDE || '',
        countryTR: countryData.countryTR || '',
        countryFR: countryData.countryFR || '',
        countryES: countryData.countryES || '',
        countryAR: countryData.countryAR || '',
        countryPT: countryData.countryPT || '',
        countryRU: countryData.countryRU || '',
        countryUR: countryData.countryUR || '',
        countryIT: countryData.countryIT || '',
        countrySR: countryData.countrySR || '',
        countryID: countryData.countryID || '',
        countryMK: countryData.countryMK || '',
        countryHU: countryData.countryHU || '',
        countryJA: countryData.countryJA || '',
        countryZH: countryData.countryZH || '',
        countryTH: countryData.countryTH || '',
      });
    } else { // Yeni ülke ekleme modu (şimdilik yok ama ileride olabilir)
      setFormData({
        country: '', flag: '', isActive: true,
        countryDE: '', countryTR: '', countryFR: '', countryES: '', countryAR: '', countryPT: '', countryRU: '', countryUR: '', countryIT: '', countrySR: '', countryID: '', countryMK: '', countryHU: '', countryJA: '', countryZH: '', countryTH: ''
      });
    }
    setFormError(''); // Modal her açıldığında hataları temizle
  }, [countryData, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');

    if (!formData.country.trim()) {
        setFormError("Varsayılan ülke adı boş bırakılamaz.");
        return;
    }

    // API'nin beklediği request body'sini oluştur
    const requestBody = {
        country: formData.country, // Bu, path'teki {countryName} ile eşleşmeli. Düzenlenirse path de değişir!
        flag: formData.flag || null, // Boşsa null gönder
        isActive: formData.isActive,
        countryDE: formData.countryDE || null,
        countryTR: formData.countryTR || null,
        countryFR: formData.countryFR || null,
        countryES: formData.countryES || null,
        countryAR: formData.countryAR || null,
        countryPT: formData.countryPT || null,
        countryRU: formData.countryRU || null,
        countryUR: formData.countryUR || null,
        countryIT: formData.countryIT || null,
        countrySR: formData.countrySR || null,
        countryID: formData.countryID || null,
        countryMK: formData.countryMK || null,
        countryHU: formData.countryHU || null,
        countryJA: formData.countryJA || null,
        countryZH: formData.countryZH || null,
        countryTH: formData.countryTH || null,
    };

    // onSave fonksiyonu (CountriesPage'den gelecek) API çağrısını yapacak
    // countryData.country -> path için orijinal ülke adı
    // requestBody -> gönderilecek veri
    const success = await onSave(countryData.country, requestBody);
    if (success) {
        onClose();
    }
    // Eğer onSave içinde hata yönetimi yapılıyorsa, modalError'a gerek kalmayabilir
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={countryData ? `"${countryData.country}" Ülkesini Düzenle` : 'Yeni Ülke Ekle'}>
      <form onSubmit={handleSubmit} className={styles.editForm}>
        {(externalError || formError) && <p className={`${styles.modalErrorText} ${styles.fullSpan}`}>{externalError || formError}</p>}

        <h3 className={`${styles.sectionHeading} ${styles.fullSpan}`}>Dil Adları</h3>

        {/* Tüm dil alanları için form alanları — geniş ekranda iki sütunlu grid */}
        {editableLanguageFields.map(langField => (
            <div key={langField.key} className={styles.formGroup}>
                <label htmlFor={langField.key}>{langField.label}</label>
                <input
                    type="text"
                    id={langField.key}
                    name={langField.key}
                    value={formData[langField.key] || ''}
                    onChange={handleChange}
                    placeholder={`${langField.label} girin`}
                    required={langField.key === 'country'} // Sadece varsayılan ülke adı zorunlu
                />
            </div>
        ))}

        <h3 className={`${styles.sectionHeading} ${styles.fullSpan}`}>Görsel & Durum</h3>

        <div className={`${styles.formGroup} ${styles.fullSpan}`}>
          <label htmlFor="flag">Bayrak URL'i</label>
          <input type="text" id="flag" name="flag" value={formData.flag} onChange={handleChange} placeholder="https://example.com/flag.png"/>
        </div>

        <div className={`${styles.formGroup} ${styles.fullSpan}`}>
          <label htmlFor="isActive" className={styles.checkboxLabel}>
            <input type="checkbox" id="isActive" name="isActive" checked={formData.isActive} onChange={handleChange} />
            Aktif mi?
          </label>
        </div>

        <div className={`${styles.modalActions} ${styles.fullSpan}`}>
          <button type="button" onClick={onClose} className={`${styles.modalButton} ${styles.cancelButton}`}>
            İptal
          </button>
          <button type="submit" className={`${styles.modalButton} ${styles.saveButton}`}>
            Kaydet
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CountryEditModal;